import PositionCardLoading from './PositionCardLoading';

interface Props {
  length?: number;
  slimmed?: boolean;
}

export const LoadingCardsContainer: React.FC<Props> = ({ length = 10, slimmed }) => (
  <div data-testid='loading-cards-container' className='flex flex-col gap-6'>
    {Array.from({ length }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <PositionCardLoading key={index} slimmed={slimmed} />
    ))}
  </div>
);
